import { DOCUMENT_STATUS_SIGNED, DOCUMENT_STATUS_SIGNED_BY_DIRECTOR } from ".";
import Status from "../components/Status";
import { colors } from "./colors";

export const DKP_SIGNINGS = ({ onSign }) => [
  {
    Header: 'ID',
    accessor: 'id',
    width: 50,
  },
  {
    Header: 'ФИО клиента',
    accessor: (row) => {
      if (!row.user) return '—';
      const { name, surname, middlename } = row.user;
      const fullName = [surname, name, middlename].filter(Boolean).join(' ');
      return fullName || '—';
    },

  },
  {
    Header: 'ИИН',
    accessor: (row) => row.user?.iin || '—',
    width: 100

  },
  {
    Header: 'Телефон',
    accessor: (row) => row.user?.phone || '—',
    width: 100
  },
  {
    Header: 'Дата создания',
    accessor: (row) => {
      if (!row.createdAt) return '—';
      const date = new Date(row.createdAt);
      return date.toLocaleDateString('ru-RU');
    },
    width: 100
  },
  {
    Header: 'Статус',
    accessor: (row) => {
      if (row.statusId == DOCUMENT_STATUS_SIGNED) {
        return <Status status="Ожидает подписания директора" color={colors.orange} />;
      } else if (row.statusId == DOCUMENT_STATUS_SIGNED_BY_DIRECTOR) {
        return <Status status="Подписан" color={colors.green} />;
      }
    },

    disableSortBy: true,
  },
  {
    Header: 'Действия',
    accessor: (row) => (
      <div style={{ display: 'flex', gap: 10, flexDirection: 'column', alignItems: 'flex-start', margin: '10px' }}>
        <a 
          href={row.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: 'pointer', color: '#0057FF', background: 'none', border: 'none', marginRight: '10px' }}
        >
          Открыть
        </a>
        {row.statusId == DOCUMENT_STATUS_SIGNED && (
          <button 
            onClick={() => onSign(row)} 
            style={{ cursor: 'pointer', color: '#0057FF', background: 'none', border: 'none' }}
          >
            Ознакомиться и подписать
          </button>
        )}
      </div>
    ),
    disableSortBy: true,
    width: 200
  },
  {
    Header: ' ',
  }
]; 